import { required, email } from 'vuelidate/lib/validators'
import validationHelpers from '@/mixins/validationHelpers.js'
import { mapGetters } from 'vuex'

export default {
  mixins: [validationHelpers],
  computed: {
    ...mapGetters({
      positions: 'positions/availablePositions',
    }),
    fields() {
      return [
        {
          key: 'name',
          attrs: {
            placeholder: 'Имя',
            type: 'text',
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.name, 'name'),
          },
        },
        {
          key: 'surname',
          attrs: {
            placeholder: 'Фамилия',
            type: 'text',
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.surname, 'surname'),
          },
        },
        {
          key: 'email',
          attrs: {
            placeholder: 'Почта',
            type: 'email',
            inputmode: 'email',
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.email, 'email'),
          },
        },
        {
          key: 'phone',
          attrs: {
            placeholder: 'Телефон',
            type: 'tel',
            inputmode: 'tel',
            maska: '+###########',
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.phone, 'phone'),
          },
        },
        {
          key: 'position',
          attrs: {
            placeholder: 'Должность',
            type: 'text',
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.position, 'position'),
          },
        },
      ]
    },
  },

  validations: {
    form: {
      name: {
        required,
      },
      surname: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
      },
      position: {
        required,
      },
    },
  },
}
